export const P = "/biuro-wirtualne-warszawa";
export const ROUTES = {
  docs: `${P}/dokumenty`,
  doc: (id) => `${P}/dokumenty/${id}`,
  upload: `${P}/wyslij-podpisany-dokument`,
  pay: `${P}/platnosc`,
  legalization: `${P}/legalizacja-dokumentow`,
  owu: `${P}/owu`,
  rodo: `${P}/rodo`,
  blog: `${P}/wiedza`,
  article: (slug) => `${P}/wiedza/${slug}`,
  staff: `${P}/dokumenty-wewnetrzne`,
  staffDoc: (id) => `${P}/dokumenty-wewnetrzne/${id}`,
  order: (pkg) => (pkg ? `${P}/zamow-pakiet/${pkg}` : `${P}/zamow-pakiet`),
  verifyOrder: `${P}/potwierdz-zamowienie`,
  verifyDocument: `${P}/potwierdz-dokument`,
};
